export default class TransitionEvent {
    constructor(type) {
        this.type = type;
    }
}

TransitionEvent.CLOSE_REQUEST = "TransitionEvent.CLOSE_REQUEST";